<script>
  import { onMount } from "svelte"
  export let headerBackground

  /**
   * @type {Number} Width of the individual color box
   */
  let width

  /**
   * @type {Array} list of svg patterns
   */
  let patterns = [
    "url(\"data:image/svg+xml;charset=utf8,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40' patternTransform='scale(SCALE) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,0%,0)'/><path d='M0 0h10v20H0zM30 0v10H10V0zM10 10h10v20H10zM40 10v10H20V10zM20 20h10v20H20zM50 20v10H30V20zM30 30h10v20H30zM20 30v10H0V30zM10 20v10h-20V20zM30-10h10v20H30z'  stroke-width='1' stroke='hsla(0,0%,100%,.15)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>\")",
    "url(\"data:image/svg+xml;charset=utf8,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='20' height='20' patternTransform='scale(SCALE) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,0%,0)'/><path d='M3.25 10h13.5M10 3.25v13.5'  stroke-linecap='square' stroke-width='1' stroke='hsla(0,0%,100%,.15)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>\")",
    "url(\"data:image/svg+xml;charset=utf8,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40' patternTransform='scale(SCALE) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,0%,0)'/><path d='M11 6a5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5'  stroke-width='1' stroke='none' fill='hsla(0,0%,100%,.15)'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>\")",
    "url(\"data:image/svg+xml;charset=utf8,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='69.141' height='40' patternTransform='scale(SCALE) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,0%,0)'/><path d='M69.212 40H46.118L34.57 20 46.118 0h23.094l11.547 20zM57.665 60H34.57L23.023 40 34.57 20h23.095l11.547 20zm0-40H34.57L23.023 0 34.57-20h23.095L69.212 0zM34.57 60H11.476L-.07 40l11.547-20h23.095l11.547 20zm0-40H11.476L-.07 0l11.547-20h23.095L46.118 0zM23.023 40H-.07l-11.547-20L-.07 0h23.094L34.57 20z'  stroke-width='1' stroke='hsla(0,0%,100%,.15)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>\")",
  ]
  /**
   * @type {HTMLElement} binded the overall palette container
   */
  let container

  onMount(() => {
    let fixedWidth
    if (window.innerWidth > 1280) fixedWidth = 49.6
    else if (window.innerWidth > 1024) fixedWidth = 45
    else if (window.innerWidth > 768) fixedWidth = 40
    else if (window.innerWidth > 640) fixedWidth = 35
    else fixedWidth = 30

    let sharedWidth = container.clientWidth / (fixedWidth * 7)
    width = fixedWidth + sharedWidth
  })
</script>

<div bind:this={container}>
  <h1 class="sm pt-2 text-base font-medium text-[#868484]">Standard Patterns</h1>
  <div class="grid gap-y-2" style="grid-template-columns: repeat(auto-fit, minmax({width}px,1fr));">
    {#each patterns as pattern}
      <div class="mb-2 h-[28.8px] rounded-md" style="background:{headerBackground};width: {width}px">
        <button class="h-full w-full" style="background:{pattern};" />
      </div>
    {/each}
    <div class="relative flex h-[28.8px] items-center justify-center pr-0.5" style="width: {width}px">
      <div class="flex h-full w-full items-center justify-center rounded-md border border-[#a0a1a580] bg-transparent">
        <i class="fa-solid fa-plus text-gray-200" />
      </div>
      <input type="color" class="absolute inset-0 h-full cursor-pointer opacity-0" />
    </div>
  </div>
</div>
